export default __webpack_public_path__ + "static/media/trophy2.06b0e875.png";